var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQualysColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1762 12.2656C40.1762 12.2656 35.0891 7 25 7C14.9109 7 9.82376 12.2656 9.82376 12.2656C9.82376 12.2656 9.25536 16.1732 9.62482 24.0162C10.1932 35.8776 25 43 25 43C25 43 39.8354 35.8776 40.3752 24.0162C40.7446 16.1732 40.1762 12.2656 40.1762 12.2656ZM32.0765 30.8337C30.2577 30.6674 28.3819 30.1686 27.5009 29.6975C29.7177 28.3118 32.5881 25.6513 32.5881 22.3811C32.5881 18.3072 29.1777 14.9815 25 14.9815C20.8223 14.9815 17.4119 18.3903 17.4119 22.5751C17.4119 26.067 19.316 28.8106 23.0674 30.7506C25.5115 31.9977 29.1777 32.9122 33.0428 33.4111C32.3892 34.3533 30.684 35.933 29.6893 36.4873C25.0568 35.739 20.9927 34.1871 18.2077 31.8314C15.2236 29.3372 13.6605 26.067 13.6605 22.3811V22.2979C13.6889 16.2009 18.7761 11.2679 25.0284 11.2956C31.2808 11.3233 36.3395 16.2841 36.3111 22.3811C36.3395 25.679 34.748 28.8106 32.0765 30.8337Z",
    fill: "#ED2E26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualysColor);
export default __webpack_public_path__ + "static/media/qualys_color.d34c4cff08acc620d76bda3b7af1efd1.svg";
export { ForwardRef as ReactComponent };